/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class HttpRequestError extends Error {
    constructor(private readonly _requestNameOrUrl: string, private readonly _response: Response) {
        super(_requestNameOrUrl);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, HttpRequestError.prototype);
    }

    public get requestNameOrUrl(): string {
        return this._requestNameOrUrl;
    }

    public get response(): Response {
        return this._response;
    }
}